import { computed, ComputedRef, reactive, ref, Ref, UnwrapRef } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
import smh from '@/renderer/scripts/smh';
import { GetShareLinkLogData } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import tips from '@/renderer/scripts/utils/tips';
type Pagination = {
  current: number;
  pageSize: number;
  total: number;
  onChange: (pageInfo: PageInfo) => void;
};

type PageInfo = {
  current: number;
  pageSize: number;
};
type TableData = {
  list: GetShareLinkLogData[];
  currentPage: number;
};
type Handler = {
  tableData: UnwrapRef<TableData>;
  methods: {
    refresh: () => void;
  };
  loading: Ref<boolean>;
  loadingStatus: Ref<string>;
  titleColumns: Array<any>;
  pagination: UnwrapRef<Pagination>;
};
export default function initList(currentItem: ComputedRef<SMH.GetShareLinkData>): Handler {
  const titleColumns = [
    {
      title: i18n_t('操作者信息'),
      colKey: 'userInfo',
      width: 150,
    },
    {
      title: i18n_t('操作时间'),
      colKey: 'operationTime',
      width: 180,
    },
    {
      title: i18n_t('操作对象'),
      colKey: 'target',
      width: 200,
    },
    {
      title: i18n_t('操作内容'),
      colKey: 'operationType',
    },
  ];

  const onPageSizeChange = (pageinfo: PageInfo) => {
    const { pageSize, current } = pageinfo;
    pagination.pageSize = pageSize;
    pagination.current = current;
    methods.pullList();
  };
  const tableData = reactive<TableData>({
    list: [],
    currentPage: 0,
  });

  const pagination = reactive<Pagination>({
    current: 1,
    pageSize: 20,
    total: 0,
    onChange: onPageSizeChange,
  });
  const loading = ref(false);
  const loadingStatus = ref('');
  const methods = {
    async refresh() {
      pagination.total = 0;
      pagination.current = 1;
      loading.value = false;
      loadingStatus.value = '';
      tableData.list = [];
      await methods.pullList();
    },
    async pullList() {
      loading.value = true;
      loadingStatus.value = 'loading';
      const opt = {
        page: pagination.current,
        pageSize: pagination.pageSize,
        shareId: currentItem.value.id,
      };
      tableData.list = [];
      try {
        const { data: listRes } = await smh.userAPI.getSharedLinkLogList(opt);
        const { totalNum, logs } = listRes;
        pagination.total = totalNum;
        tableData.list = logs;
      } catch (error) {
        tips.error(error as MsgError);
      }
      loading.value = false;
      loadingStatus.value = '';
    },
  };
  return {
    tableData,
    methods,
    loading,
    loadingStatus,
    titleColumns,
    pagination,
  };
}
